import React from 'react';
import { useLabels, usePrefs } from 'ws-scripts/modules/common';

import { isPrefEnabled } from '../utils/prefUtils';
import CTAButton from './CTAButton';

/**
 * DrawerCTAButtons — renders the My Cars and My Wallet CTA buttons.
 *
 * Individual button visibility is controlled by `enableMyCars` and
 * `enableMyWallet` prefs read here. The parent is responsible for deciding
 * whether to render this component at all (outer visibility gate).
 */
const DrawerCTAButtons = () => {
	const { enableMyCars, enableMyWallet } = usePrefs();
	const labels = useLabels();

	return (
		<div
			className="ws-nav-drawer__cta-buttons d-flex py-5 px-4"
			data-testid="drawer-cta-buttons"
		>
			{isPrefEnabled(enableMyCars) && (
				<CTAButton
					iconClass="ddc-icon-mycars-login"
					label={labels.get('MY_CARS')}
					testId="drawer-cta-mycars"
				/>
			)}
			{isPrefEnabled(enableMyWallet) && (
				<CTAButton
					iconClass="ddc-icon-mywallet"
					label={labels.get('MY_WALLET')}
					testId="drawer-cta-mywallet"
				/>
			)}
		</div>
	);
};

export default DrawerCTAButtons;
